import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  onClose: () => void
  onConfirm: () => void
  showModal: boolean
}

export default function ConfirmUndoChangesModal({
  onClose,
  onConfirm,
  showModal,
}: Props) {
  return (
    <Modal isCentered isOpen={showModal} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader paddingTop={SIZE.s40}>
          <PDSHeader variant="h4">
            Are you sure you want to undo all changes?
          </PDSHeader>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <PDSBox></PDSBox>
          <PDSBox display="grid" gap={SIZE.s24}>
            <PDSText>
              This will reset all the changes you’ve made to your current
              investment preferences.
            </PDSText>
          </PDSBox>
        </ModalBody>
        <PDSSeparator marginTop={SIZE.s16} />
        <ModalFooter paddingTop={SIZE.s12}>
          <PDSFlexBox
            flexDirection="column"
            gap={SIZE.s8}
            margin={SIZE.s16}
            width="100%"
          >
            <PDSButton
              onClick={onConfirm}
              size="md-f"
              text="Undo All Changes"
              variant="danger"
            />

            <PDSButton
              onClick={onClose}
              size="md-f"
              text="Cancel"
              variant="tertiary"
            />
          </PDSFlexBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
